import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import GroupsTable from "../../../containers/admin/groups/table";
import SearchBar from "../../../containers/admin/groups/searchbar";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import AddGroup from "../../../containers/admin/groups/models/add-group";

const Groups = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <GroupsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddGroup
        key={`group-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Groups;
